import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button, Modal, ModalBody, ModalFooter, Input } from "reactstrap";
import Icon from "@material-ui/core/Icon";
import ReactDatePicker from "react-datepicker";
import InputFeild from "../../global/form/input";
import SelectList from "../../global/form/select";
import { setError, setLoader } from "../../../actions/action-creators";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import moment from "moment";
import ConfirmAction from "../../global/confirm-action";

const ORIGIN_TYPE_OPTIONS = [
    { value: "JOB_CATEGORY",     label: "Job Category" },
    { value: "JOB_TASK",         label: "Job Task" },
    { value: "HOME_LEADERBOARD", label: "Home Leaderboard" },
    { value: "REFERRAL",         label: "Referral" },
    { value: "RECHARGE",         label: "Recharge" },
];

function isValidUrl(str) {
    try { return Boolean(new URL(str)); } catch { return false; }
}

const LABEL = {
    fontSize: 11, fontWeight: 700, letterSpacing: "0.6px",
    textTransform: "uppercase", color: "#666", marginBottom: 6, display: "block",
};

const TYPE_BADGE = {
    IMAGE: { bg: "#e8f5e9", color: "#2e7d32", icon: "image" },
    HTML:  { bg: "#e3f2fd", color: "#1565c0", icon: "code"  },
};

class HeroBanners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            bannerList: [],
            clickMap: {},
            clicksLoaded: false,
            revealedClicks: {},
            jobCategoryList: [],
            showExpired: false,
            previewImageUrl: null,
            isOpenConfirm: false,
            bannerFile: null,
            bannerPreviewUrl: null,
            draggedBannerIndex: null,
            form: null,
        };
    }

    componentDidMount() {
        this.fetchBannerList();
        this.fetchJobCategories();
    }

    toggleClickReveal = async (promotionId) => {
        const { clicksLoaded, revealedClicks } = this.state;
        if (!clicksLoaded) {
            try {
                const resp = await ApiEndpoints.Marketing.fetchHeroBannerClicks();
                const map = {};
                (resp.data.data || []).forEach(row => { map[row.promotion_id] = Number(row.click_count); });
                this.setState({ clickMap: map, clicksLoaded: true });
            } catch (e) { /* non-critical */ }
        }
        this.setState(prev => ({
            revealedClicks: { ...prev.revealedClicks, [promotionId]: !prev.revealedClicks[promotionId] }
        }));
    }

    fetchJobCategories = async () => {
        try {
            let resp = await ApiEndpoints.Jobs.fetchCategory();
            this.setState({ jobCategoryList: resp.data.data });
        } catch (e) { /* non-critical */ }
    }

    fetchBannerList = async () => {
        store.dispatch(setLoader(true));
        try {
            let apiData = await ApiEndpoints.Marketing.fetchBanners({ purpose: "HERO_BANNER" });
            this.setState({ bannerList: apiData.data.data || [] });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    delete = async (promotion_id) => {
        store.dispatch(setLoader(true));
        try {
            await ApiEndpoints.Marketing.deleteBanner({ promotion_id });
            await this.fetchBannerList();
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    handleDragInput = (e) => { this.setState({ draggedBannerIndex: e.currentTarget.id }); }

    handleDropInput = async (e) => {
        let { draggedBannerIndex } = this.state;
        let droppedBannerIndex = e.currentTarget.id;
        if (!draggedBannerIndex || !droppedBannerIndex) return;
        let banners = [...this.state.bannerList];
        let draggedBanner = banners.splice(draggedBannerIndex, 1);
        if (!draggedBanner[0]) return;
        banners.splice(droppedBannerIndex, 0, draggedBanner[0]);
        banners = banners.map((b, i) => { b.seq_no = i + 1; return b; });
        let updateData = banners
            .filter((_, i) => draggedBannerIndex > droppedBannerIndex ? i >= droppedBannerIndex : i >= draggedBannerIndex && i <= droppedBannerIndex)
            .map(b => ({ promotion_id: b.promotion_id, seq_no: b.seq_no }));
        await Promise.all(updateData.map(b => ApiEndpoints.Marketing.updateBanner(b)));
        this.setState({ bannerList: [...banners] });
    }

    openModal  = () => this.setState({ isOpen: true, form: { contentType: "IMAGE", actionType: "SCREEN" }, bannerFile: null, bannerPreviewUrl: null });
    closeModal = () => this.setState({ isOpen: false, form: null, bannerFile: null, bannerPreviewUrl: null });

    buildActionJSON = () => {
        const { form } = this.state;
        if (!form || form.contentType === "HTML") return null;
        if (form.actionType === "LINK") return JSON.stringify({ type: "LINK", value: form.link_url || "" });
        const obj = { type: "SCREEN", origin_type: form.origin_type || "" };
        if (form.origin_id) obj.origin_id = Number(form.origin_id);
        return JSON.stringify(obj);
    }

    isFormValid = () => {
        const { form, bannerFile } = this.state;
        if (!form) return false;
        if (!form.title || !form.start_date || !form.end_date) return false;
        if (form.contentType === "IMAGE") {
            if (!bannerFile) return false;
            if (form.actionType === "LINK" && !isValidUrl(form.link_url || "")) return false;
        }
        if (form.contentType === "HTML" && !(form.html_content || "").trim()) return false;
        return true;
    }

    createBanner = async (e) => {
        e.preventDefault();
        const { form } = this.state;
        store.dispatch(setLoader(true));
        try {
            const bannerData = {
                purpose:    "HERO_BANNER",
                title:      form.title,
                seq_no:     this.state.bannerList.length + 1,
                start_date: form.start_date,
                end_date:   form.end_date,
                content_type: form.contentType,
            };

            if (form.contentType === "IMAGE") {
                const file     = this.state.bannerFile;
                const fileName = "promotions/banner/" + new Date().getTime() + "_" + file.name;
                const fileResp = await ApiEndpoints.Files.filePublicPutUrl({ file_name: fileName });
                await ApiEndpoints.Files.uploadFileToS3(fileResp.data.data.url, file, { headers: { "Content-Type": file.type } });
                bannerData.poster_url = fileResp.data.data.fileUrl;
                bannerData.action     = form.rawAction !== undefined ? form.rawAction : this.buildActionJSON();
            } else {
                bannerData.html_content = form.html_content;
            }

            await ApiEndpoints.Marketing.createBanner(bannerData);
            await this.fetchBannerList();
            this.closeModal();
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    }

    setForm = (patch) => {
        this.setState(prev => ({ form: { ...prev.form, ...patch } }));
    }

    render() {
        const { isOpen, bannerList, clickMap, revealedClicks, bannerPreviewUrl, jobCategoryList, showExpired, previewImageUrl, form } = this.state;
        const isExpired      = (b) => b.end_date && moment().isAfter(moment(b.end_date));
        const visibleBanners = showExpired ? bannerList : bannerList.filter(b => !isExpired(b));
        const expiredCount   = bannerList.filter(isExpired).length;
        const jobList        = store.getState().jobList || [];
        const f              = form || {};
        const actionType     = f.actionType || "SCREEN";
        const urlInvalid     = actionType === "LINK" && f.link_url && !isValidUrl(f.link_url);
        const valid          = this.isFormValid();

        return (
            <>
                {/* ── Toolbar ── */}
                <Row className="mb-3 align-items-center">
                    <Col>
                        <Button onClick={this.openModal} type="button" className="buttonred" size="sm">
                            <Icon style={{ fontSize: 15, verticalAlign: "middle", marginRight: 5 }}>add</Icon>
                            Add Hero Banner
                        </Button>
                    </Col>
                    <Col className="text-right" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 12 }}>
                        {expiredCount > 0 && (
                            <button
                                type="button"
                                onClick={() => this.setState({ showExpired: !showExpired })}
                                style={{
                                    background: "none", border: "1px solid #ccc", borderRadius: 6,
                                    padding: "3px 10px", fontSize: 12, cursor: "pointer",
                                    color: showExpired ? "#f1061c" : "#888",
                                    borderColor: showExpired ? "#f1061c" : "#ccc",
                                    fontWeight: showExpired ? 600 : 400,
                                }}
                            >
                                <Icon style={{ fontSize: 13, verticalAlign: "middle", marginRight: 4 }}>
                                    {showExpired ? "visibility_off" : "visibility"}
                                </Icon>
                                {showExpired ? "Hide" : "Show"} expired ({expiredCount})
                            </button>
                        )}
                        <small className="text-muted">{visibleBanners.length} banner{visibleBanners.length !== 1 ? "s" : ""} · drag to reorder</small>
                    </Col>
                </Row>

                {/* ════════════ MODAL ════════════ */}
                <Modal isOpen={isOpen} toggle={this.closeModal} size="lg" centered>
                    <div style={{
                        background: "#f1061c", borderRadius: "6px 6px 0 0",
                        padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
                    }}>
                        <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>Add Hero Banner</span>
                        <button type="button" onClick={this.closeModal}
                            style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", padding: 4, lineHeight: 1 }}>
                            <Icon style={{ fontSize: 20 }}>close</Icon>
                        </button>
                    </div>

                    <ModalBody style={{ padding: "24px 28px 12px" }}>
                        <form id="hero-banner-form" onSubmit={this.createBanner}>

                            {/* Content Type toggle */}
                            <div style={{ marginBottom: 20 }}>
                                <label style={LABEL}>Content Type</label>
                                <div style={{ display: "flex", border: "1px solid #d5d8dc", borderRadius: 6, overflow: "hidden" }}>
                                    {[{ key: "IMAGE", label: "Image Banner" }, { key: "HTML", label: "HTML / Interactive" }].map((tab, idx, arr) => {
                                        const active = f.contentType === tab.key;
                                        return (
                                            <button key={tab.key} type="button"
                                                onClick={() => this.setForm({ contentType: tab.key })}
                                                style={{
                                                    flex: 1, padding: "10px 0", border: "none", cursor: "pointer",
                                                    fontWeight: 700, fontSize: 13,
                                                    borderRight: idx < arr.length - 1 ? "1px solid #d5d8dc" : "none",
                                                    background: active ? "#f1061c" : "#f8f9fa",
                                                    color: active ? "#fff" : "#777",
                                                    transition: "background 0.15s, color 0.15s",
                                                }}>
                                                <Icon style={{ fontSize: 14, verticalAlign: "middle", marginRight: 5 }}>
                                                    {tab.key === "IMAGE" ? "image" : "code"}
                                                </Icon>
                                                {tab.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Title + Dates */}
                            <Row style={{ marginBottom: 18 }}>
                                <Col xs={12} style={{ marginBottom: 14 }}>
                                    <label style={LABEL}>Title <span style={{ color: "#f1061c" }}>*</span></label>
                                    <InputFeild
                                        placeholder="e.g. Diwali Campaign"
                                        value={f.title || ""}
                                        onChange={(e) => this.setForm({ title: e.target.value })}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <label style={LABEL}>Start Date <span style={{ color: "#f1061c" }}>*</span></label>
                                    <ReactDatePicker
                                        selected={f.start_date || null}
                                        maxDate={f.end_date || null}
                                        onChange={date => this.setForm({ start_date: date })}
                                        isClearable dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd/mm/yyyy"
                                        className="form-control" wrapperClassName="d-block"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <label style={LABEL}>End Date <span style={{ color: "#f1061c" }}>*</span></label>
                                    <ReactDatePicker
                                        selected={f.end_date || null}
                                        minDate={f.start_date || null}
                                        onChange={date => this.setForm({ end_date: date })}
                                        isClearable dateFormat="dd-MMM-yyyy"
                                        placeholderText="dd/mm/yyyy"
                                        className="form-control" wrapperClassName="d-block"
                                    />
                                </Col>
                            </Row>

                            {/* ── IMAGE fields ── */}
                            {f.contentType === "IMAGE" && (
                                <>
                                    <div style={{ marginBottom: 18 }}>
                                        <label style={LABEL}>Banner Image <span style={{ color: "#f1061c" }}>*</span></label>
                                        <label htmlFor="hero-file-input" style={{
                                            display: "block", border: "2px dashed #d5d8dc", borderRadius: 8,
                                            padding: bannerPreviewUrl ? 0 : "30px 24px",
                                            textAlign: "center", cursor: "pointer",
                                            background: bannerPreviewUrl ? "transparent" : "#fdfefe",
                                            overflow: "hidden", position: "relative",
                                        }}
                                            onMouseOver={e => e.currentTarget.style.borderColor = "#f1061c"}
                                            onMouseOut={e => e.currentTarget.style.borderColor = "#d5d8dc"}
                                        >
                                            {bannerPreviewUrl ? (
                                                <>
                                                    <img src={bannerPreviewUrl} alt="preview"
                                                        style={{ width: "100%", maxHeight: 150, objectFit: "cover", display: "block", borderRadius: 6 }} />
                                                    <div style={{
                                                        position: "absolute", bottom: 0, left: 0, right: 0,
                                                        background: "rgba(0,0,0,0.45)", color: "#fff",
                                                        fontSize: 11, padding: "5px 0", textAlign: "center",
                                                    }}>Click to replace image</div>
                                                </>
                                            ) : (
                                                <>
                                                    <Icon style={{ fontSize: 32, color: "#d5d8dc", display: "block", margin: "0 auto 8px" }}>cloud_upload</Icon>
                                                    <div style={{ fontSize: 13, color: "#666" }}>
                                                        Drag &amp; drop or <span style={{ color: "#f1061c", fontWeight: 600 }}>browse</span> to upload
                                                    </div>
                                                    <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>PNG, JPG, GIF supported</div>
                                                </>
                                            )}
                                            <input id="hero-file-input" type="file" accept="image/*" style={{ display: "none" }}
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (!file) return;
                                                    this.setState({ bannerFile: file, bannerPreviewUrl: URL.createObjectURL(file) });
                                                }} />
                                        </label>
                                    </div>

                                    {/* Action on tap */}
                                    <div style={{ marginBottom: 14 }}>
                                        <label style={LABEL}>Action (on banner tap)</label>
                                        <div style={{ display: "flex", border: "1px solid #d5d8dc", borderRadius: 6, overflow: "hidden", marginBottom: 14 }}>
                                            {[{ key: "SCREEN", label: "Select Project" }, { key: "LINK", label: "Direct URL" }].map((tab, idx, arr) => {
                                                const active = actionType === tab.key;
                                                return (
                                                    <button key={tab.key} type="button"
                                                        onClick={() => this.setForm({ actionType: tab.key })}
                                                        style={{
                                                            flex: 1, padding: "10px 0", border: "none", cursor: "pointer",
                                                            fontWeight: 700, fontSize: 13,
                                                            borderRight: idx < arr.length - 1 ? "1px solid #d5d8dc" : "none",
                                                            background: active ? "#f1061c" : "#f8f9fa",
                                                            color: active ? "#fff" : "#777",
                                                            transition: "background 0.15s, color 0.15s",
                                                        }}>
                                                        {tab.label}
                                                    </button>
                                                );
                                            })}
                                        </div>

                                        {actionType === "SCREEN" && (
                                            <Row>
                                                <Col xs={6}>
                                                    <label style={LABEL}>Project Type</label>
                                                    <Input type="select" value={f.origin_type || ""}
                                                        onChange={(e) => this.setForm({ origin_type: e.target.value, origin_id: "" })}
                                                        style={{ borderRadius: 6, fontSize: 13, height: 38 }}>
                                                        <option value="" disabled>-- Select Type --</option>
                                                        {ORIGIN_TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                                    </Input>
                                                </Col>
                                                <Col xs={6}>
                                                    {f.origin_type === "JOB_CATEGORY" && (
                                                        <>
                                                            <label style={LABEL}>Job Category <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                            <SelectList search placeholder="All Categories" value={f.origin_id || ""}
                                                                onChange={(e) => this.setForm({ origin_id: e.target.value })}>
                                                                {jobCategoryList.map(cat => (
                                                                    <option key={cat.job_category_id} value={cat.job_category_id}>{cat.title}</option>
                                                                ))}
                                                            </SelectList>
                                                        </>
                                                    )}
                                                    {f.origin_type === "JOB_TASK" && (
                                                        <>
                                                            <label style={LABEL}>Job <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                            <SelectList search placeholder="All Jobs" value={f.origin_id || ""}
                                                                onChange={(e) => this.setForm({ origin_id: e.target.value })}>
                                                                {jobList.map(job => (
                                                                    <option key={job.job_id} value={job.job_id}>{job.Employer.employer_name} — {job.title}</option>
                                                                ))}
                                                            </SelectList>
                                                        </>
                                                    )}
                                                    {f.origin_type && !["JOB_CATEGORY", "JOB_TASK"].includes(f.origin_type) && (
                                                        <>
                                                            <label style={LABEL}>Origin ID <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                                            <InputFeild placeholder="e.g. 4" value={f.origin_id || ""}
                                                                onChange={(e) => this.setForm({ origin_id: e.target.value })} />
                                                        </>
                                                    )}
                                                </Col>
                                            </Row>
                                        )}

                                        {actionType === "LINK" && (
                                            <div>
                                                <label style={LABEL}>Redirect URL <span style={{ color: "#f1061c" }}>*</span></label>
                                                <InputFeild placeholder="https://go.pickmywork.com/..."
                                                    value={f.link_url || ""}
                                                    onChange={(e) => this.setForm({ link_url: e.target.value })} />
                                                {urlInvalid && (
                                                    <div style={{ fontSize: 11, color: "#f1061c", marginTop: 5 }}>
                                                        <Icon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 3 }}>error_outline</Icon>
                                                        Must be a valid URL starting with https://
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* JSON — editable, pre-filled from controls above */}
                                        <textarea
                                            rows={2} spellCheck={false}
                                            value={f.rawAction !== undefined ? f.rawAction : (this.buildActionJSON() || "")}
                                            onChange={e => this.setForm({ rawAction: e.target.value })}
                                            style={{
                                                width: "100%", background: "#f4f6f7", border: "1px solid #e5e8e8",
                                                borderRadius: 6, padding: "9px 14px", fontSize: 12, fontFamily: "monospace",
                                                color: "#333", resize: "vertical", outline: "none", lineHeight: 1.5, marginTop: 12,
                                            }}
                                        />
                                    </div>
                                </>
                            )}

                            {/* ── HTML fields ── */}
                            {f.contentType === "HTML" && (
                                <div style={{ marginBottom: 14 }}>
                                    <label style={LABEL}>HTML Code <span style={{ color: "#f1061c" }}>*</span></label>
                                    <textarea
                                        value={f.html_content || ""}
                                        onChange={(e) => this.setForm({ html_content: e.target.value })}
                                        placeholder={"<div>Your Lottie animation or campaign HTML here...</div>"}
                                        rows={10}
                                        spellCheck={false}
                                        style={{
                                            width: "100%", border: "1px solid #d5d8dc", borderRadius: 6,
                                            padding: "10px 14px", fontFamily: "monospace", fontSize: 12,
                                            color: "#333", resize: "vertical", outline: "none",
                                            lineHeight: 1.6,
                                        }}
                                    />
                                    <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                                        Full HTML snippet — include any inline &lt;style&gt; and &lt;script&gt; tags needed.
                                    </div>
                                </div>
                            )}
                        </form>
                    </ModalBody>

                    <ModalFooter style={{ padding: "14px 28px", borderTop: "1px solid #f0f0f0", gap: 10 }}>
                        <Button type="button" onClick={this.closeModal} style={{
                            minWidth: 90, fontSize: 13, fontWeight: 600,
                            background: "#fff", color: "#f1061c",
                            border: "1.5px solid #f1061c", borderRadius: 6,
                        }}>Cancel</Button>
                        <Button form="hero-banner-form" type="submit" disabled={!valid} style={{
                            minWidth: 100, fontSize: 13, fontWeight: 600,
                            background: valid ? "#f1061c" : "#d4948f", border: "none",
                            color: "#fff", borderRadius: 6, transition: "background 0.15s",
                        }}>Create</Button>
                    </ModalFooter>
                </Modal>

                {/* ════════════ BANNER LIST ════════════ */}
                <div style={{
                    display: "grid", gridTemplateColumns: "40px 1fr 80px 180px 80px 100px 100px 40px",
                    alignItems: "center", padding: "10px 20px 10px 16px",
                    background: "#2c3e50", borderRadius: "8px 8px 0 0",
                    fontSize: 11, fontWeight: 700, letterSpacing: "0.5px",
                    textTransform: "uppercase", color: "#bdc3c7",
                }}>
                    <div>#</div>
                    <div>Title</div>
                    <div>Type</div>
                    <div>Preview</div>
                    <div style={{ textAlign: "center" }}>Clicks</div>
                    <div>Start</div>
                    <div>End</div>
                    <div></div>
                </div>

                {visibleBanners.length ? (
                    <div style={{ border: "1px solid #e8e8e8", borderTop: "none", borderRadius: "0 0 8px 8px", overflow: "hidden" }}>
                        {visibleBanners.map((banner, i) => {
                            const badge = TYPE_BADGE[banner.content_type] || TYPE_BADGE.IMAGE;
                            return (
                                <div key={i} id={i}
                                    draggable
                                    onDragOver={(ev) => ev.preventDefault()}
                                    onDragStart={this.handleDragInput}
                                    onDrop={this.handleDropInput}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "40px 1fr 80px 180px 80px 100px 100px 40px",
                                        alignItems: "center",
                                        padding: "10px 20px 10px 16px",
                                        background: i % 2 === 0 ? "#fff" : "#fafafa",
                                        borderBottom: i < visibleBanners.length - 1 ? "1px solid #f0f0f0" : "none",
                                        cursor: "grab", fontSize: 13,
                                    }}
                                >
                                    {/* Seq */}
                                    <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Icon style={{ fontSize: 14, color: "#ccc" }}>drag_indicator</Icon>
                                        <span style={{ fontSize: 11, color: "#bbb", fontWeight: 600 }}>{banner.seq_no || i + 1}</span>
                                    </div>

                                    {/* Title + ID + Action */}
                                    <div style={{ paddingRight: 8 }}>
                                        <div style={{ fontWeight: 600, color: "#222", marginBottom: 2 }}>{banner.title}</div>
                                        <div style={{ fontSize: 11, color: "#bbb" }}>#{banner.promotion_id}</div>
                                        {banner.action && (
                                            <div style={{ fontSize: 11, color: "#aaa", marginTop: 3, fontFamily: "monospace", wordBreak: "break-all" }}>
                                                {typeof banner.action === "string" ? banner.action : JSON.stringify(banner.action)}
                                            </div>
                                        )}
                                    </div>

                                    {/* Type badge */}
                                    <div>
                                        <span style={{
                                            display: "inline-flex", alignItems: "center", gap: 4,
                                            background: badge.bg, color: badge.color,
                                            borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 700,
                                        }}>
                                            <Icon style={{ fontSize: 12 }}>{badge.icon}</Icon>
                                            {banner.content_type}
                                        </span>
                                    </div>

                                    {/* Preview */}
                                    <div>
                                        {banner.content_type === "IMAGE" && banner.poster_url ? (
                                            <img src={banner.poster_url} alt=""
                                                title="Click to preview"
                                                onClick={() => this.setState({ previewImageUrl: banner.poster_url })}
                                                style={{ width: 140, objectFit: "cover", borderRadius: 6, border: "1px solid #eee", display: "block", cursor: "zoom-in" }}
                                            />
                                        ) : (
                                            <div style={{
                                                width: 140, height: 40, borderRadius: 6,
                                                background: "#e3f2fd", border: "1px solid #bbdefb",
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                fontSize: 11, color: "#1565c0", fontWeight: 600, gap: 4,
                                            }}>
                                                <Icon style={{ fontSize: 14 }}>code</Icon>
                                                HTML Slide
                                            </div>
                                        )}
                                    </div>

                                    {/* Clicks */}
                                    <div style={{ textAlign: "center" }}>
                                        {revealedClicks[banner.promotion_id] ? (
                                            <>
                                                <div style={{ fontWeight: 700, fontSize: 16, color: "#222" }}>{clickMap[banner.promotion_id] || 0}</div>
                                                <div style={{ fontSize: 10, color: "#aaa", marginTop: 1, cursor: "pointer" }}
                                                    onClick={() => this.toggleClickReveal(banner.promotion_id)}>hide</div>
                                            </>
                                        ) : (
                                            <Icon title="Show clicks" onClick={() => this.toggleClickReveal(banner.promotion_id)}
                                                style={{ fontSize: 18, color: "#aaa", cursor: "pointer" }}>
                                                visibility
                                            </Icon>
                                        )}
                                    </div>

                                    {/* Dates */}
                                    <div style={{ fontSize: 12, color: "#555" }}>
                                        {banner.start_date ? moment(banner.start_date).utcOffset("+05:30").format("D MMM'YY") : "—"}
                                    </div>
                                    <div style={{ fontSize: 12, color: isExpired(banner) ? "#f1061c" : "#555" }}>
                                        {banner.end_date ? moment(banner.end_date).utcOffset("+05:30").format("D MMM'YY") : "—"}
                                        {isExpired(banner) && <span style={{ fontSize: 10, marginLeft: 4, opacity: 0.7 }}>(expired)</span>}
                                    </div>

                                    {/* Delete */}
                                    <div style={{ textAlign: "right" }}>
                                        <Icon title="Delete" style={{ cursor: "pointer", fontSize: 17, color: "#f1061c" }}
                                            onClick={() => this.setState({ isOpenConfirm: () => this.delete(banner.promotion_id) })}>
                                            delete
                                        </Icon>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{
                        border: "1px solid #e8e8e8", borderTop: "none", borderRadius: "0 0 8px 8px",
                        padding: "50px 20px", textAlign: "center",
                    }}>
                        <Icon style={{ fontSize: 40, color: "#e0e0e0", display: "block", margin: "0 auto 10px" }}>web_stories</Icon>
                        <em style={{ fontSize: 13, color: "#aaa" }}>No hero banners yet. Click "Add Hero Banner" to get started.</em>
                    </div>
                )}

                {/* Image lightbox */}
                {previewImageUrl && (
                    <div onClick={() => this.setState({ previewImageUrl: null })}
                        style={{
                            position: "fixed", inset: 0, zIndex: 9999,
                            background: "rgba(0,0,0,0.78)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "zoom-out",
                        }}
                    >
                        <img src={previewImageUrl} alt="preview"
                            style={{ maxWidth: "90vw", maxHeight: "88vh", borderRadius: 8, boxShadow: "0 8px 40px rgba(0,0,0,0.5)" }} />
                        <button onClick={() => this.setState({ previewImageUrl: null })}
                            style={{
                                position: "absolute", top: 20, right: 24,
                                background: "rgba(255,255,255,0.15)", border: "none",
                                borderRadius: "50%", width: 36, height: 36,
                                color: "#fff", fontSize: 20, cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                            <Icon style={{ fontSize: 20 }}>close</Icon>
                        </button>
                    </div>
                )}

                <ConfirmAction
                    isOpen={!!this.state.isOpenConfirm}
                    callback={this.state.isOpenConfirm}
                    onClose={() => this.setState({ isOpenConfirm: false })}
                />
            </>
        );
    }
}

export default HeroBanners;
